

































import Vue from "vue";
import { VuetifyThemeItem } from "vuetify/types/services/theme";

export default Vue.extend({
    name: "Loader"
});
